var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanvasEventPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 89.9999,
    height: 89.9999,
    rx: 15,
    transform: "matrix(0.707107 0.707106 -0.707107 0.707106 64 0.279053)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 33.9187,
    width: 60,
    height: 59.9999,
    rx: 30,
    fill: "#FFFAE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.8742 55.5213C50.2892 51.6686 53.0057 48.208 57.1554 46.9401C57.8918 46.7165 58.6857 46.7813 59.3761 47.1214C60.0665 47.4615 60.6017 48.0514 60.8732 48.7715L62.2054 52.324C62.4199 52.8955 62.4587 53.5181 62.3168 54.1118C62.1749 54.7055 61.8589 55.2432 61.4092 55.656L57.4463 59.2851C57.2507 59.4642 57.105 59.691 57.0234 59.9433C56.9418 60.1956 56.9271 60.4648 56.9808 60.7245L57.0176 60.8837L57.1125 61.2818C57.6066 63.2158 58.3574 65.075 59.3451 66.8096C60.4234 68.6515 61.76 70.3294 63.3141 71.7923L63.4366 71.9026C63.6344 72.0782 63.8744 72.1995 64.133 72.2548C64.3917 72.3101 64.6603 72.2974 64.9127 72.218L70.0362 70.6041C70.6185 70.4213 71.2421 70.4166 71.8271 70.5907C72.412 70.7647 72.9317 71.1096 73.3192 71.581L75.7447 74.5241C76.7554 75.7491 76.6329 77.5498 75.4722 78.6309C72.2964 81.5923 67.9292 82.1987 64.8912 79.7579C61.1658 76.7557 58.0262 73.0918 55.6302 68.9503C53.2108 64.8143 51.5991 60.2578 50.8742 55.5213ZM60.1903 60.9266L63.4733 57.9131C64.3732 57.0878 65.0059 56.0125 65.2902 54.8251C65.5745 53.6377 65.4974 52.3924 65.0689 51.2491L63.7397 47.6966C63.1945 46.2473 62.118 45.06 60.7289 44.3757C59.3399 43.6914 57.7425 43.5615 56.2611 44.0124C51.1069 45.5896 46.9695 50.2109 47.8454 55.9837C48.4579 60.014 49.8697 65.1406 52.9842 70.4938C55.5693 74.9593 58.956 78.9097 62.9741 82.1466C67.5311 85.8063 73.6132 84.5568 77.5639 80.8757C78.6943 79.8232 79.3804 78.379 79.4823 76.8378C79.5842 75.2966 79.0941 73.7746 78.1121 72.5825L75.6866 69.6363C74.9106 68.6946 73.8711 68.006 72.7012 67.659C71.5314 67.3119 70.2845 67.3223 69.1206 67.6886L64.8667 69.0269C63.7684 67.8946 62.8063 66.6375 62.0002 65.2815C61.2224 63.9101 60.6156 62.4486 60.1934 60.9296",
    fill: "#B39200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasEventPhone);
export default __webpack_public_path__ + "static/media/canvas_event_phone.4266b354b1b0687a1d41f80120c88e27.svg";
export { ForwardRef as ReactComponent };